import { render, staticRenderFns } from "./MyProductCoupons.vue?vue&type=template&id=6b24e5ba&"
import script from "./MyProductCoupons.vue?vue&type=script&lang=ts&"
export * from "./MyProductCoupons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports